import { c as _c } from "react/compiler-runtime";
import { Button, LoadingSpinner, PageShell } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type LinkBankAccountProps = {
  isLoading: boolean;
  onLaunch: () => void;
};
export const LinkBankAccount = t0 => {
  const $ = _c(13);
  const {
    isLoading,
    onLaunch
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "linkBankAccount"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp2);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isLoading || $[6] !== onLaunch || $[7] !== t) {
    t4 = <div className="flex flex-col items-center justify-center gap-6">{isLoading ? <LoadingSpinner size="xlarge" /> : <Button onClick={onLaunch}>{t(_temp3)}</Button>}</div>;
    $[5] = isLoading;
    $[6] = onLaunch;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <PageShell title={t2} subtitle={t3}>{t4}</PageShell>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.subtitle;
}
function _temp3($_1) {
  return $_1.cta;
}